class BrandsAdminSettingsModalContainer {
  constructor(
    $q,
    appErrorHandler,
    appEvents,
    appSessionCapabilities,
    brands,
    permissions,
    users,
    BRANDS_EVENTS,
  ) {
    'ngInject';

    this.$q = $q;
    this.appErrorHandler = appErrorHandler;
    this.appEvents = appEvents;
    this.appSessionCapabilities = appSessionCapabilities;
    this.brands = brands;
    this.permissions = permissions;
    this.users = users;
    this.BRANDS_EVENTS = BRANDS_EVENTS;

    this.removeOpenSubscription = this.appEvents.on(
      this.BRANDS_EVENTS.adminSettings.open,
      (brand) => this.openModal(brand),
    );

    this.modalTitle = 'Admin Settings';
    this.brand = {};
    this.users = [];
    this.scopes = [];
    this.open = false;
    this.loading = false;

    this.settings = {
      users: [],
      permissions: [],
    };
  }
  $onDestroy() {
    this.removeOpenSubscription();
  }
  openModal(brand) {
    this.modalTitle = `${brand.displayName} - Admin Settings`;
    this.brand = brand;
    this.users = this.brand.user_accounts.slice();
    this.settings = {
      users: [],
      permissions: [],
    };
    this.userQuery = '';
    this.open = true;
    this._loadData();
  }
  closeModal() {
    this.open = false;
    this.appEvents.emit(this.BRANDS_EVENTS.adminSettings.close);
  }
  saveModal() {
    let result;
    if (this.loading) {
      result = this.$q.reject(new Error('The information are already being saved'));
    } else {
      this.loading = true;
      this.error = '';
      result = this.brands.saveAdminSettings(
        this.brand.id,
        this.settings.users,
        this.settings.permissions,
      )
      .then(() => {
        this.appEvents.emit(this.BRANDS_EVENTS.adminSettings.save);
        this.closeModal();
      })
      .catch((error) => {
        this.appErrorHandler.handle(error, 'There was an error while saving the settings');
      })
      .then(() => {
        this.loading = false;
      });
    }

    return result;
  }
  toggleUser(user, isSelected) {
    this._toggleEntity('users', user, isSelected);
  }
  toggleUsers(users, selectAll) {
    this._toggleEntitiesList('users', users, selectAll);
  }
  togglePermission(permission, isSelected) {
    this._toggleEntity('permissions', permission, isSelected);
  }
  _toggleEntity(from, entity, isSelected) {
    const list = this.settings[from];
    if (isSelected) {
      const index = list.indexOf(entity.id);
      if (index > -1) {
        list.splice(index, 1);
      }
    } else if (!list.includes(entity.id)) {
      list.push(entity.id);
    }
  }
  _toggleEntitiesList(from, entities, selectAll) {
    entities.forEach((entity) => {
      this._toggleEntity(from, entity, !selectAll);
    });
  }
  _loadData() {
    this.loading = true;
    this.permissions.scopesWithPermissions(true)
    .then((scopes) => {
      this.scopes = scopes;
      return this.brands.adminSettings(this.brand.id);
    })
    .then((response) => {
      this.settings.permissions = response.permissions.map((permission) => permission.id);
      this.settings.users = [];
      response.user_accounts.forEach((user) => {
        this.settings.users.push(user.id);
        if (!this.users.find((item) => item.id === user.id)) {
          this.users.push(user);
        }
      });
    })
    .catch((error) => {
      this.appErrorHandler.handle(
        error,
        'There was an error loading the information, please try again',
      );
      this.closeModal();
    })
    .then(() => {
      this.loading = false;
    });
  }
}

export default {
  controller: BrandsAdminSettingsModalContainer,
  template: `
    <modal-wrapper
      ng-if="$ctrl.open"
      modal-title="$ctrl.modalTitle"
      on-close="$ctrl.closeModal()"
    >
      <brands-admin-settings-form
        loading="$ctrl.loading"
        on-cancel="$ctrl.closeModal()"
        on-save="$ctrl.saveModal()"

        users="$ctrl.users"
        saved-users="$ctrl.settings.users"
        on-toggle-user="$ctrl.toggleUser(user, isSelected)"
        on-toggle-users-list="$ctrl.toggleUsers(users, selectAll)"

        scopes="$ctrl.scopes"
        saved-permissions="$ctrl.settings.permissions"
        on-toggle-permission="$ctrl.togglePermission(permission, isSelected)"
      ></brands-admin-settings-form>
    </modal-wrapper>
  `,
};
